import { groupLifeProposalsService } from '@/services/proposals/group-life';
import type { GroupLifeQuoteDetails } from '@/services/group-life';
import { useQuery } from '@tanstack/react-query';

/**
 * Snapshot PME (estipulante, subestipulantes, plano, comercialização e
 * cálculo) de uma apólice já emitida.
 *
 * O endpoint fica sob `proposals`, mas no BFF ele reusa a mesma query de
 * `quotes` e lê o snapshot do InsureMO por `policyId` — vale para qualquer
 * estágio, inclusive apólice emitida. É a única fonte desses dados para o
 * 930016: a factory de apólice do produto não preenche `customers`, `agents`
 * nem `lobs` na resposta de `/emissions/policies/:policyId`.
 */
export function usePmePolicyProposal(policyId: string | undefined) {
  return useQuery<GroupLifeQuoteDetails>({
    queryKey: ['pme-policy-proposal', policyId],
    queryFn: async () => {
      const result = await groupLifeProposalsService.getProposalDetails(
        policyId as string
      );
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Erro ao carregar os dados da apólice PME'
        );
      }
      return result.data;
    },
    enabled: Boolean(policyId),
    staleTime: 5 * 60 * 1000,
  });
}
